{
  "titles": {
    "menu": "Spaarders",
    "table": "Spaarders",
    "create": "Spaarder aanmaken",
    "update": "Spaarder wijzigen",
    "contracts": "Contracten",
    "accounts": "Accounts",
    "details": "Gegevens",
    "files": "Documenten",
    "archivedFiles": "Gearchiveerd"
  },
  "fields": {
    "labels": {
      "businessName": "Bedrijfsnaam",
      "legalStructure": "Rechtsvorm",
      "registrationNumber": "KvK-nummer",
      "registeredOffice": "Statutaire zetel",
      "officeAddress": "Adres",
      "representativeName": "Vertegenwoordiger",
      "advisorId": "Adviseur",
      "type": "Soort spaarder",

      "isBusinessInformationValidated": "KVK uittreksel & statuten controle",
      "false-isIdentityValidated": "Identiteit spaarder is niet gecontroleerd",
      "false-isBusinessInformationValidated": "KVK uittreksel & statuten zijn niet gecontroleerd",
      "representativeId": "Vertegenwoordiger",
      "representativeEmail": "E-mailadres",
      "representativePhone": "Telefoonnummer",
      "email": "E-mailadres",
      "phone": "Telefoonnummer",
      "signingAuthorities": "Tekenbevoegden",
      "isAllowedToManageContracts": "Mag eigen contracten beheren"
    },
    "hints": {
    },
    "placeholders": {
      "advisorId": "Toewijzen aan mijzelf"
    }
  },
  "headers": {
    "labels": {
      "advisorName": "Adviseur",
      "numberOfActiveContracts": "Actieve contracten",
      "totalActiveContractAmount": "Actieve inleg",
      "name": "Naam"
    }
  },
  "messages": {
    "createSuccess": "Spaarder aangemaakt",
    "updateSuccess": "Spaarder is opgeslagen",
    "noAdvisorId": "Eigen netwerk",
    "isRepresentative": "vertegenwoordiger",
    "missingDataBeginning": "Er mist data bij ",
    "missingFunderData": "de gegevens van",
    "funder": " de spaarder",
    "missingDataEnd": "Vul deze aan, zodat we een contract naar de spaarder kunnen sturen!\n",
    "and": " en ",
     "noFiles": "Geen documenten beschikbaar"
  },
  "actions": {
    "create": "Spaarder aanmaken",
    "update": "Spaarder aanpassen",
    "search": "Zoek een spaarder"
  },
  "declarationOfSourceOfFunds": {
    "fields": {
      "labels": {
        "fundingContractReferenceNumber": "Gekoppeld aan",
        "archivedFundingContractReferenceNumbers": "Gekoppeld aan {count} contracten"
      }
    },
    "actions": {
      "showAdditionalDocuments": "Toon aanvullende documenten",
      "hideAdditionalDocuments": "Verberg aanvullende documenten"
    }
  }
}
